import { lazyRouteComponent } from '@tanstack/react-router';
import { ClipboardList } from 'lucide-react';
import type { WebModule } from '../web-module.ts';

/** Módulo Pedidos nas telas (catálogo beadev-ai/catalogo). Os textos ficam em `orders.*`. */
export const webModule: WebModule = {
  id: 'orders',
  areas: [
    {
      id: 'orders',
      key: 'orders.area',
      icon: ClipboardList,
      groups: [
        {
          key: null,
          items: [
            {
              to: '/orders',
              key: 'orders.nav.list',
              icon: ClipboardList,
              permission: ['orders.order.read', 'orders.order.manage'],
            },
          ],
        },
      ],
    },
  ],
  routes: [
    {
      path: '/orders',
      component: lazyRouteComponent(() => import('./OrdersPage.tsx'), 'OrdersPage'),
    },
  ],
  permissionAreas: [
    {
      id: 'orders',
      key: 'orders.area',
      processes: [
        {
          id: 'orders',
          key: 'orders.process',
          permissions: ['orders.order.read', 'orders.order.manage'],
        },
      ],
    },
  ],
};
